// Canadian security industry shared keyword layer.
// These strings are appended to every service and every city page's <meta keywords>
// and rendered as an internal-linked keyword strip. Existing URLs are unchanged.
//
// Grouped by intent for readability, but the flattened array is what components consume.

const general = [
  "security guard services Canada",
  "Canadian security industry",
  "licensed security guard Canada",
  "bonded and insured security Canada",
  "24 hour security guard services",
  "24/7 security company Canada",
  "professional security services Canada",
  "private security firm Canada",
  "commercial security services Canada",
  "commissionaires alternative Canada",
  "hire security guard Canada",
  "on-demand security guards Canada",
  "temporary security guards Canada",
  "same day security deployment Canada",
];

const roles = [
  "uniformed security officer",
  "loss prevention officer Canada",
  "concierge security officer",
  "mobile patrol supervisor",
  "security site inspector",
  "pedestrian security patroller",
  "static security officer",
  "roving security officer",
  "front-desk security officer",
  "overnight security guard",
  "weekend security guard",
  "female security guards Canada",
  "off-duty police officers Canada",
  "close protection officer CPO Canada",
  "executive protection agent Canada",
];

const regulatory = [
  "provincial security license Canada",
  "BSP licensed Quebec security",
  "Bureau de la sécurité privée Quebec",
  "CNESST compliant security Quebec",
  "ISO 18788 aligned security",
  "PSISA compliant security officer",
  "ASIS certified security professional",
  "CANASA member security firm",
  "IAHSS aligned healthcare security",
  "Loi 25 compliant CCTV",
  "Transport Canada MTSA compliant",
  "ISPS Code aligned port security",
];

const services = [
  "physical security services Canada",
  "manned guarding Canada",
  "corporate security officer",
  "workplace violence prevention Canada",
  "cash-in-transit Canada",
  "armored transport Canada",
  "cargo security Canada",
  "warehouse security Canada",
  "distribution centre security Canada",
  "healthcare security Canada",
  "hospital security officer",
  "long-term care security",
  "campus security officer",
  "university security services",
  "CEGEP security services",
  "event security services Canada",
  "festival security Canada",
  "concert crowd management Canada",
  "stadium security Canada",
  "K9 detection services Canada",
  "explosive detection K9",
  "narcotic detection K9",
  "fire watch services Canada",
  "sprinkler shutdown fire watch",
  "hot work fire watch Canada",
  "construction site security Canada",
  "copper theft prevention Canada",
  "jobsite security officer",
  "retail loss prevention services Canada",
  "organized retail crime deterrent",
  "mall security services Canada",
  "residential security officer",
  "condominium security Canada",
  "gated community security Canada",
  "estate security officer",
  "hotel security officer",
  "resort security Canada",
  "hospitality security services",
  "marine port security Canada",
  "yacht marina security Canada",
  "mining site security Canada",
  "remote site security Canada",
  "FIFO camp security Canada",
  "oil gas facility security Canada",
  "refinery security Canada",
  "pipeline security Canada",
  "hydroelectric substation security",
  "cannabis retail security Canada",
  "cannabis licensed producer security",
  "data centre physical security Canada",
  "colocation facility security",
  "diplomatic mission security Canada",
  "consulate security Canada",
  "government building security Canada",
  "courthouse security Canada",
  "municipal building security Canada",
  "film production security Canada",
  "set security officer",
  "art gallery museum security Canada",
  "biotech laboratory security Canada",
  "renewable energy security Canada",
  "wind farm security Canada",
  "railway yard security Canada",
];

const french = [
  "agence de sécurité Québec",
  "gardien de sécurité Québec",
  "agent de sécurité Montréal",
  "surveillance privée Québec",
  "protection privée Québec",
  "sécurité corporative Québec",
  "sécurité résidentielle Québec",
  "sécurité événementielle Québec",
  "patrouille mobile Québec",
  "sécurité minière Québec",
  "intervention sur alarme Québec",
  "sécurité 24 heures Québec",
  "sécurité bilingue Québec",
];

const intent = [
  "how much does a security guard cost",
  "security guard rates per hour Canada",
  "best security company Canada",
  "top rated security firm Canada",
  "security guard company near me",
  "emergency security dispatch Canada",
  "verified alarm response Canada",
  "sub 12 minute alarm response",
  "security guard insurance certificate",
  "security firm liability coverage",
  "insured security officers Canada",
];

export const sharedCanadianKeywords = [
  ...general,
  ...roles,
  ...regulatory,
  ...services,
  ...french,
  ...intent,
];

// Compact list for meta description / keyword strips (top 40 by SEO value)
export const topCanadianKeywords = [...new Set([
  ...general.slice(0, 10),
  "manned guarding Canada",
  "physical security services Canada",
  "24 hour security guard services",
  "licensed security guard Canada",
  "bonded and insured security Canada",
  "commissionaires alternative Canada",
  "close protection officer CPO Canada",
  "cash-in-transit Canada",
  "mining site security Canada",
  "K9 detection services Canada",
  "fire watch services Canada",
  "construction site security Canada",
  "retail loss prevention services Canada",
  "hospital security officer",
  "campus security officer",
  "cannabis retail security Canada",
  "data centre physical security Canada",
  "event security services Canada",
  "festival security Canada",
  "stadium security Canada",
  "port security Canada",
  "warehouse security Canada",
  "condominium security Canada",
  "estate security officer",
  "agence de sécurité Québec",
  "agent de sécurité Montréal",
  "sécurité minière Québec",
  "security guard rates per hour Canada",
  "best security company Canada",
])];
